(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("dompurify"), require("prop-types"), require("redux"));
	else if(typeof define === 'function' && define.amd)
		define([, , , ], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react"), require("dompurify"), require("prop-types"), require("redux")) : factory(root[undefined], root[undefined], root[undefined], root[undefined]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, (__WEBPACK_EXTERNAL_MODULE__5225__, __WEBPACK_EXTERNAL_MODULE__710__, __WEBPACK_EXTERNAL_MODULE__6073__, __WEBPACK_EXTERNAL_MODULE__5293__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 9787:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export ConnectStateWrapper */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5225);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _remote_data_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3511);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }



/*
  Connect a react component to a global store.
  This is similar to what react-redux does but uses our global store so
  can share state with other React mount points or anything that uses the
  store.
  - selectors is an object where keys are your prop names and values are your select
  functions that work on the store to retrieve the state you are interested in
  - initial state is set in useEffect so the wrapped component needs to handle it's props set to undefined initially
*/

var ConnectStateWrapper = function ConnectStateWrapper(Component, selectors) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({}),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var setStateForKey = function setStateForKey(key) {
    return function (storeState) {
      return setState(function () {
        return _defineProperty({}, key, storeState);
      });
    };
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var store = (0,_remote_data_store__WEBPACK_IMPORTED_MODULE_1__/* .getRemoteDataStore */ .cO)();
    var resolvedState = Object.keys(selectors).reduce(function (acc, key) {
      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, selectors[key](store)));
    }, {}); // Set initial state

    setState(resolvedState); // Create a store subscription for each selector. Depending on your use case, this can be inefficient.
    // When optimising for renders, look for wins with selectors better for your use and using connectState directly.

    Object.keys(selectors).forEach(function (key) {
      (0,_remote_data_store__WEBPACK_IMPORTED_MODULE_1__/* .connectState */ .kZ)(selectors[key], setStateForKey(key));
    });
  }, []);

  var WrappedComponent = function WrappedComponent(props) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(Component, _extends({}, props, state));
  };

  return WrappedComponent;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ConnectStateWrapper);

/***/ }),

/***/ 9008:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5225);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6073);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
var _excluded = ["name", "size", "color", "additionalCSS"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var Icon = function Icon(_ref) {
  var name = _ref.name,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "0.75rem" : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "" : _ref$color,
      _ref$additionalCSS = _ref.additionalCSS,
      additionalCSS = _ref$additionalCSS === void 0 ? "" : _ref$additionalCSS,
      additionalAttributes = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("svg", _extends({
    className: "".concat(color, " ").concat(additionalCSS),
    style: {
      width: size,
      height: size
    }
  }, additionalAttributes), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("use", {
    xlinkHref: "#sprite-".concat(name)
  }));
};

Icon.propTypes = {
  name: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string.isRequired),
  size: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  color: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  additionalCSS: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string)
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Icon);

/***/ }),

/***/ 3511:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cO": () => (/* binding */ getRemoteDataStore),
/* harmony export */   "kZ": () => (/* binding */ connectState)
/* harmony export */ });
/* unused harmony exports attachStoreToWindow, createRemoteDataStore */
/* harmony import */ var redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5293);
/* harmony import */ var redux__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(redux__WEBPACK_IMPORTED_MODULE_0__);

var attachStoreToWindow = function attachStoreToWindow(store) {
  window.AblyUi = window.AblyUi || {};
  window.AblyUi.RemoteDataStore = store;
};
var getRemoteDataStore = function getRemoteDataStore() {
  if (!window.AblyUi.RemoteDataStore) {
    throw new Error("Remote store was called before one was created");
  }

  return window.AblyUi.RemoteDataStore;
};
var connectState = function connectState(selector, setState) {
  var store = getRemoteDataStore();
  var cachedOldState = selector(store);
  store.subscribe(function () {
    var newState = selector(store); // Do nothing, state is the same

    if (newState === cachedOldState) {
      return;
    }

    cachedOldState = newState;
    setState(newState);
  });
};
var createRemoteDataStore = function createRemoteDataStore(reducers) {
  return createStore(combineReducers(reducers));
};

/***/ }),

/***/ 710:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__710__;

/***/ }),

/***/ 6073:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__6073__;

/***/ }),

/***/ 5225:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__5225__;

/***/ }),

/***/ 5293:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__5293__;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
(() => {
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "FLASH_DATA_ID": () => (/* binding */ FLASH_DATA_ID),
  "Flashes": () => (/* binding */ Flashes),
  "default": () => (/* binding */ Flash_component),
  "reducerFlashes": () => (/* binding */ reducerFlashes)
});

// EXTERNAL MODULE: external {"commonjs":"react","commonjs2":"react"}
var external_commonjs_react_commonjs2_react_ = __webpack_require__(5225);
var external_commonjs_react_commonjs2_react_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_react_commonjs2_react_);
// EXTERNAL MODULE: external {"commonjs":"dompurify","commonjs2":"dompurify"}
var external_commonjs_dompurify_commonjs2_dompurify_ = __webpack_require__(710);
var external_commonjs_dompurify_commonjs2_dompurify_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_dompurify_commonjs2_dompurify_);
// EXTERNAL MODULE: external {"commonjs":"prop-types","commonjs2":"prop-types"}
var external_commonjs_prop_types_commonjs2_prop_types_ = __webpack_require__(6073);
var external_commonjs_prop_types_commonjs2_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_prop_types_commonjs2_prop_types_);
;// CONCATENATED MODULE: ./node_modules/nanoid/non-secure/index.js
let urlAlphabet =
  'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict'
let customAlphabet = (alphabet, defaultSize = 21) => {
  return (size = defaultSize) => {
    let id = ''
    let i = size
    while (i--) {
      id += alphabet[(Math.random() * alphabet.length) | 0]
    }
    return id
  }
}
let nanoid = (size = 21) => {
  let id = ''
  let i = size
  while (i--) {
    id += urlAlphabet[(Math.random() * 64) | 0]
  }
  return id
}

// EXTERNAL MODULE: ./src/core/remote-data-store.js
var remote_data_store = __webpack_require__(3511);
// EXTERNAL MODULE: ./src/core/ConnectStateWrapper/component.jsx
var component = __webpack_require__(9787);
// EXTERNAL MODULE: ./src/core/Icon/component.jsx
var Icon_component = __webpack_require__(9008);
;// CONCATENATED MODULE: ./src/core/Flash/component.jsx
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }








var REDUCER_KEY = "flashes";
var FLASH_DATA_ID = "ui-flashes";
var initialState = {
  items: []
};

var reducerFlashes = _defineProperty({}, REDUCER_KEY, function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case "flash/push":
      {
        var flashes = Array.isArray(action.payload) ? action.payload : [action.payload];
        return {
          items: [].concat(_toConsumableArray(state.items), _toConsumableArray(flashes))
        };
      }

    default:
      return state;
  }
});

var selectFlashes = function selectFlashes(store) {
  return store.getState()[REDUCER_KEY];
};

var FlashT = {
  type: external_commonjs_prop_types_commonjs2_prop_types_default().oneOf(["error", "success", "notice", "info", "alert"]),
  content: (external_commonjs_prop_types_commonjs2_prop_types_default()).string
};
var FLASH_BG_COLOR = {
  error: "bg-gui-error",
  success: "bg-zingy-green",
  notice: "bg-electric-cyan",
  info: "bg-electric-cyan",
  alert: "bg-active-orange"
};
var FLASH_TEXT_COLOR = {
  error: "text-white",
  success: "text-cool-black",
  notice: "text-cool-black",
  info: "text-cool-black",
  alert: "text-white"
};
var AUTO_HIDE = ["success", "info", "notice"];
var AUTO_HIDE_TIME = 8000;

var useAutoHide = function useAutoHide(type, closeFlash) {
  var timeoutId = (0,external_commonjs_react_commonjs2_react_.useRef)(null);
  (0,external_commonjs_react_commonjs2_react_.useEffect)(function () {
    if (AUTO_HIDE.includes(type)) {
      timeoutId.current = setTimeout(function () {
        closeFlash();
      }, AUTO_HIDE_TIME);
    }

    return function () {
      if (timeoutId.current) {
        clearTimeout(timeoutId.current);
      }
    };
  }, []);
};

var Flash = function Flash(_ref) {
  var id = _ref.id,
      type = _ref.type,
      content = _ref.content,
      removeFlash = _ref.removeFlash;
  var ref = (0,external_commonjs_react_commonjs2_react_.useRef)(null);

  var _useState = (0,external_commonjs_react_commonjs2_react_.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      closed = _useState2[0],
      setClosed = _useState2[1];

  var _useState3 = (0,external_commonjs_react_commonjs2_react_.useState)(0),
      _useState4 = _slicedToArray(_useState3, 2),
      flashHeight = _useState4[0],
      setFlashHeight = _useState4[1];

  var _useState5 = (0,external_commonjs_react_commonjs2_react_.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      triggerEntryAnimation = _useState6[0],
      setTriggerEntryAnimation = _useState6[1];

  var closeFlash = function closeFlash() {
    if (ref.current) {
      setFlashHeight(ref.current.getBoundingClientRect().height);
    }

    setClosed(true);
    setTimeout(function () {
      removeFlash(id);
    }, 100);
  };

  (0,external_commonjs_react_commonjs2_react_.useEffect)(function () {
    return setTriggerEntryAnimation(true);
  }, []);
  useAutoHide(type, closeFlash);
  var animateEntry = triggerEntryAnimation && !closed;
  var style;

  if (flashHeight && !closed) {
    style = {
      height: "".concat(flashHeight, "px")
    };
  } else if (closed) {
    style = {
      height: 0,
      marginTop: 0,
      zIndex: -1
    };
  } else {
    style = {};
  }

  var safeContent = external_commonjs_dompurify_commonjs2_dompurify_default().sanitize(content, {
    ALLOWED_TAGS: ["a"],
    ALLOWED_ATTR: ["href", "data-method", "rel"]
  });
  var withIcons = {
    notice: "icon-gui-ably-badge",
    success: "icon-gui-tick",
    error: "icon-gui-warning",
    alert: "icon-gui-warning"
  };
  var iconColor = {
    notice: "text-cool-black",
    success: "text-cool-black",
    error: "text-white",
    alert: "text-white"
  };
  return /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "ui-flash-message ui-grid-px ".concat(animateEntry ? "ui-flash-message-enter" : ""),
    style: style,
    ref: ref,
    "data-id": "ui-flash"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "".concat(FLASH_BG_COLOR[type], " p-32 flex align-center rounded shadow-container-subtle")
  }, withIcons[type] && /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement(Icon_component["default"], {
    name: withIcons[type],
    color: iconColor[type],
    size: "1.5rem",
    additionalCSS: "mr-16 self-baseline"
  }), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("p", {
    className: "ui-text-p1 mr-16 ".concat(FLASH_TEXT_COLOR[type]),
    dangerouslySetInnerHTML: {
      __html: safeContent
    }
  }), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("button", {
    type: "button",
    className: "p-0 ml-auto self-start focus:outline-none",
    onClick: closeFlash
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement(Icon_component["default"], {
    name: "icon-gui-close",
    color: iconColor[type],
    size: "1.5rem",
    additionalCSS: "transition-colors"
  }))));
};

Flash.propTypes = _objectSpread({}, FlashT);

var Flashes = function Flashes(_ref2) {
  var flashes = _ref2.flashes;

  var _useState7 = (0,external_commonjs_react_commonjs2_react_.useState)([]),
      _useState8 = _slicedToArray(_useState7, 2),
      flashesWithIds = _useState8[0],
      setFlashesWithIds = _useState8[1];

  var removeFlash = function removeFlash(flashId) {
    return setFlashesWithIds(function (items) {
      return items.filter(function (item) {
        return item.id !== flashId;
      });
    });
  };

  (0,external_commonjs_react_commonjs2_react_.useEffect)(function () {
    setFlashesWithIds(function (state) {
      return [].concat(_toConsumableArray(state), _toConsumableArray(((flashes === null || flashes === void 0 ? void 0 : flashes.items) || []).map(function (flash) {
        return _objectSpread(_objectSpread({}, flash), {}, {
          id: nanoid(),
          removed: false
        });
      })));
    });
  }, [flashes]);
  return /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "ui-flash",
    "data-id": FLASH_DATA_ID
  }, flashesWithIds.filter(function (item) {
    return !item.removed;
  }).map(function (flash) {
    return /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement(Flash, _extends({
      removeFlash: removeFlash,
      key: flash.id
    }, flash));
  }));
};

Flashes.propTypes = {
  flashes: external_commonjs_prop_types_commonjs2_prop_types_default().shape({
    items: external_commonjs_prop_types_commonjs2_prop_types_default().arrayOf(external_commonjs_prop_types_commonjs2_prop_types_default().shape(FlashT))
  })
};

var BackendFlashes = function BackendFlashes(_ref3) {
  var flashes = _ref3.flashes;
  (0,external_commonjs_react_commonjs2_react_.useEffect)(function () {
    var transformedFlashes = flashes.map(function (flash) {
      var _flash = _slicedToArray(flash, 2),
          type = _flash[0],
          content = _flash[1];

      return {
        type: type,
        content: content
      };
    }) || [];

    if (transformedFlashes.length > 0) {
      var store = (0,remote_data_store/* getRemoteDataStore */.cO)();
      store.dispatch({
        type: "flash/push",
        payload: transformedFlashes
      });
    }
  }, []);
  var WrappedFlashes = (0,component["default"])(Flashes, {
    flashes: selectFlashes
  });
  return /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement(WrappedFlashes, null);
};

BackendFlashes.propTypes = {
  flashes: external_commonjs_prop_types_commonjs2_prop_types_default().arrayOf(external_commonjs_prop_types_commonjs2_prop_types_default().arrayOf((external_commonjs_prop_types_commonjs2_prop_types_default()).string))
};

/* harmony default export */ const Flash_component = (BackendFlashes);
})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});